import { Snackbar, Alert } from "@mui/material";

const defaultState = { open: false, message: "", severity: "info" };

function SquareOffResultSnackbar({ state = defaultState, onClose = () => {} }) {
  return (
    <Snackbar
      open={state.open}
      autoHideDuration={6000}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert onClose={onClose} severity={state.severity} variant="filled">
        {state.message}
      </Alert>
    </Snackbar>
  );
}

export default SquareOffResultSnackbar;
